import { render, staticRenderFns } from "./fbiDetail.vue?vue&type=template&id=17b2e742&scoped=true&"
import script from "./fbiDetail.vue?vue&type=script&lang=js&"
export * from "./fbiDetail.vue?vue&type=script&lang=js&"
import style0 from "./fbiDetail.vue?vue&type=style&index=0&id=17b2e742&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2e742",
  null
  
)

export default component.exports